import { Component, OnInit } from '@angular/core';
import { AppMenuContributor } from './menu-contributor';
import { AppTitleService } from './shared/services/title.service';
import { SectionService } from './shared/services/section.service';
import { UserCacheService } from './shared/services/user-cache.service';
import { DropdownCacheService } from './shared/services/dropdown-cache.service';
import { FormConfigurationCacheService } from './shared/services/form-configuration-cache.service';

@Component({
  selector: 'app-root',
  template: `
    <abp-loader-bar></abp-loader-bar>
    <abp-dynamic-layout></abp-dynamic-layout>
  `,
  standalone: false,
})
export class AppComponent implements OnInit {

  constructor(
    private menuContributor: AppMenuContributor,
    private appTitleService: AppTitleService,
    private sectionService: SectionService,
    private userCacheService: UserCacheService,
    private dropdownCacheService: DropdownCacheService,
    private formConfigCacheService: FormConfigurationCacheService
  ) {}

  ngOnInit() {
    // Initialize menu after Angular's injection context is established
    this.menuContributor.buildMenu();
    
    // Initialize dynamic title service
    this.appTitleService.initializeDynamicTitles();
    
    // Initialize caches early for better performance
    this.initializeCaches();
  }
  
  /**
   * Initialize all caches on app startup
   * This prevents multiple API calls when navigating between components
   */
  private async initializeCaches(): Promise<void> {
    try {
      // Initialize caches in parallel
      await Promise.all([
        this.sectionService.init(),
        this.userCacheService.refresh(),
        this.dropdownCacheService.init(),
        this.formConfigCacheService.init()
      ]);
    } catch (error) {
      console.warn('Error initializing caches:', error);
    }
  }
}
